import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IOrderHistoryView, IOrderHistoryViewProductDisplayAttribute} from '../orders-models';
import {Util} from "../../util/util";

@Component({
    selector: 'order-history-product-row',
    templateUrl: './order-history-product-row.component.html',
    styleUrls: ['../orders.scss', './order-history-product-row.component.scss'],
    standalone: false
})
export class OrderHistoryProductRowComponent implements OnInit {
	@Input() orderView: IOrderHistoryView;
	@Input() displayAttributes: IOrderHistoryViewProductDisplayAttribute[] = [];
	@Input() displayVolume = false;
	@Input() headerLabels = [];
	@Output() readonly itemAdded = new EventEmitter();

	ngOnInit(): void {
		this.removeVolumeRelatedData();
	}

    get hasProducts() {
        return this.orderView?.products?.length > 0;
    }

	removeVolumeRelatedData() {
		if (!this.displayVolume) {
            this.displayAttributes = this.displayAttributes.filter(itemDisplayAttribute => itemDisplayAttribute.name !== 'totalVolume' && itemDisplayAttribute.name !== 'volume');
            this.headerLabels = this.headerLabels.filter(
                label => label !== 'cart.order.history.product.volume' && label !== 'cart.order.history.order.total.volume'
            );
		}
	}

    trackByFn(index: any) {
        return Util.trackByFn(index);
    }
}
